package one.devsbox.www.provider

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.Stable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.platform.LocalWindowInfo
import androidx.compose.ui.unit.IntSize
import kotlinx.browser.window

@Suppress("unused")
val LocalDisplayProvider =
    staticCompositionLocalOf<DisplayProvider> { error("LocalDisplayProvider is not implemented by CompositionLocalProvider") }


class DisplayProvider {

    var state by mutableStateOf(State())
    private set

    @Stable
    data class State(
        val size: IntSize = IntSize(1, 1),
        val portrait: Boolean = false,
        val mobile: Boolean = false,
        val tablet: Boolean = false,
        val mediumScreen: Boolean = false,
        val smallScreen: Boolean = false,
        val extraSmallScreen: Boolean = false,
        val desktop: Boolean = false,
    )

    companion object {
        @Composable
        fun remember(): DisplayProvider {
            val windowInfo = LocalWindowInfo.current
            val display = androidx.compose.runtime.remember { DisplayProvider() }
            LaunchedEffect(windowInfo.containerSize) {
                display.update(windowInfo.containerSize)
            }
            return display
        }
    }

    private fun update(containerSize: IntSize) {
        val ua = window.navigator.userAgent.lowercase()
        val isMobile =
            ua.contains("mobi") || ua.contains("android") || ua.contains("iphone") || ua.contains("ipod")
        val isTablet =
            ua.contains("tablet") || ua.contains("ipad") || (ua.contains("macintosh") && (window.navigator.asDynamic().maxTouchPoints as? Int
                ?: 0) > 1)

        val portrait = containerSize.height > containerSize.width
        val isSmallScreen = containerSize.width < 800 ||  portrait
        val isExtraSmallScreen = containerSize.width < 700

        state = State(
            size = containerSize,
            portrait = portrait,
            mobile = isMobile,
            tablet = isTablet,
            mediumScreen =  containerSize.width < 900,
            smallScreen = isSmallScreen,
            extraSmallScreen = isExtraSmallScreen,
            desktop = !isMobile && !isTablet
        )
    }
}